// extracted by mini-css-extract-plugin
export var dropdown = "dropdown-2XA";
export var dropdown_trigger = "dropdown_trigger-2G0";
export var is_showing = "is_showing-1Z1";
export var dropdown_menu = "dropdown_menu-2vj";